var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text-sm text-gray-200 font-semibold hover:text-white cursor-pointer bg-gray-800 hover:bg-gray-900 py-1 px-4 rounded-md",on:{"click":_vm.logout}},[_c('fa-icon',{attrs:{"icon":"lock"}}),_c('span',{staticClass:"ml-4 hidden md:inline-block"},[_vm._v("Déconnexion")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }